module.exports = __webpack_public_path__ + "static/media/clock.883edf81.svg";